<mat-card>
    <mat-card-title fxLayout="row">
      <div fxFlex>Administrador de ediciones</div>
    </mat-card-title>
    <mat-card-content>
      <div *ngIf="dataSource.loading$ | async">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <mat-table [dataSource]="dataSource" matSort matSortActive="publishDates" matSortDirection="desc" matSortDisableClear>
        <ng-container matColumnDef="publishDates">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Fecha(s) </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.publishDates.length === 1"> {{element.publishDates| date: 'yyyy/MM/dd'}} </div>
            <div *ngIf="element.publishDates.length > 1"> {{element.publishDates[0]| date: 'yyyy/MM/dd'}} - {{element.publishDates[element.publishDates.length -1] | date: 'yyyy/MM/dd'}} </div>
          </mat-cell>
        </ng-container>
        <!-- <ng-container matColumnDef="productCode">
          <mat-header-cell *matHeaderCellDef> Código </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.productCode}} </mat-cell>
        </ng-container> -->
        <ng-container matColumnDef="closeDate">
          <mat-header-cell *matHeaderCellDef> Cierre </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.closeDate | date: 'yyyy/MM/dd HH:mm aa'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Estado </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef> Cantidad Edictos </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.count}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>
            <a (click)="openNewEditionModule()" matTooltip="Nuevo" mat-icon-button>
              <mat-icon>add</mat-icon>
            </a>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="deleteEdition(element.id)" color="warn" matTooltip="Eliminar"  *ngIf="element.status === 'C'">
                <mat-icon aria-label="Eliminar">delete</mat-icon>
            </button>
            <!-- <button mat-icon-button color="warn" matTooltip="Restaurar" (click)="restoreProduct(element)" >
                <mat-icon aria-label="Restaurar">restore</mat-icon>
            </button> -->
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"> </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator [length]="dataSource.count" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
    </mat-card-content>
  </mat-card>
